import store from "./store";
import config from "./config"
class MyUploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }


    upload = () => {
        return this.loader.file
            .then(file => new Promise((resolve, reject) => {
                var _store = store
                const body = new FormData();
                body.append('session', store.state.userInfo.session);
                body.append('userId', store.state.userInfo.systemUserId);
                body.append('imageFile', file);
                body.append('lang', "en_US")
                return fetch(config.fileUploadUrl, {
                        body: body,
                        method: 'POST',
                    })
                    .then(response => response.json())
                    .then(result => {
                        resolve({
                            default: result.result.fullName
                        });
                    })
                    .catch(error => {
                        reject(error)
                        console.log(error);
                    });
            }));
    }
    abort = () => {
        console.log('Abort upload.')
    }
}

function MyCustomUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        return new MyUploadAdapter(loader);
    };
}

export {
    MyUploadAdapter,
    MyCustomUploadAdapterPlugin
}